appSocial.service('SocialAPIService', ['$http', 'SocialConfig', 'constants', 'md5', 'SocialTypes',
    function ($http, config, constants, md5, SocialTypes) {

        const {ApiRequestAction, ApiMethod} = SocialTypes;

        class SocialAPIService {
            constructor() {
                this.http = $http;
                this.config = config;
                this.constants = constants;

                this.currentHostName = 'dev';
                this.apiConfig = config.api;

                /**
                 * @type {{[key: string]: (params?: any, options?: any) => Promise<any>}}
                 */
                this.request = {
                    login: this.createRestMethod(ApiRequestAction.Login, ApiMethod.Post),
                    getPortfolio: this.createRestMethod(ApiRequestAction.GetPortfolio, ApiMethod.Get),
                    getFeed: this.createRestMethod(ApiRequestAction.GetFeed, ApiMethod.Get),
                    getLeaders: this.createRestMethod(ApiRequestAction.GetLeaders, ApiMethod.Get),
                    followByLeader: this.createRestMethod(ApiRequestAction.FollowByLeader, ApiMethod.Post),
                    updateFollowState: this.createRestMethod(ApiRequestAction.UpdateFollowState, ApiMethod.Put),
                    updateFollowDeposit: this.createRestMethod(ApiRequestAction.UpdateFollowDeposit, ApiMethod.Put),
                    unfollowLeader: this.createRestMethod(ApiRequestAction.UnfollowLeader, ApiMethod.Delete),
                    getFavorites: this.createRestMethod(ApiRequestAction.GetFavorites, ApiMethod.Get),
                    addFavorite: this.createRestMethod(ApiRequestAction.AddFavorite, ApiMethod.Post),
                    deleteFavorite: this.createRestMethod(ApiRequestAction.DeleteFavorite, ApiMethod.Delete),
                    getTrades: this.createRestMethod(ApiRequestAction.GetTrades, ApiMethod.Get),
                    getAggregatedTrades: this.createRestMethod(ApiRequestAction.GetAggregatedTrades, ApiMethod.Get),
                    getTradesByMarkets: this.createRestMethod(ApiRequestAction.GetTradesByMarkets, ApiMethod.Get),
                    getGainHistory: this.createRestMethod(ApiRequestAction.GetGainHistory, ApiMethod.Get),
                    getRiskHistory: this.createRestMethod(ApiRequestAction.GetRiskHistory, ApiMethod.Get),
                    getDailyData: this.createRestMethod(ApiRequestAction.GetDailyData, ApiMethod.Get),
                    updateVisitCounter: this.createRestMethod(ApiRequestAction.UpdateVisitCounter, ApiMethod.Put),
                    getExposure: this.createRestMethod(ApiRequestAction.GetExposure, ApiMethod.Get),
                    //configuration
                    getConversionRates: this.createRestMethod(ApiRequestAction.GetConversionRates, ApiMethod.Get),
                    getMarkets: this.createRestMethod(ApiRequestAction.GetMarkets, ApiMethod.Get),
                }
            }

            /**
             * @param {string} action
             * @param {string} method
             * @param cache
             * @return {()=>Promise<any>}
             */
            createRestMethod(action, method, cache = false) {
                switch (method) {
                    case ApiMethod.Get:
                        return (params = '', options = []) => this.restMethodGet(action, params, options, cache);
                    case ApiMethod.Post:
                        return (params = [], path = '') => this.restMethodPost(action, path, params);
                    case ApiMethod.Put:
                        return (params = '', payload = {}) => this.restMethodPut(action, params, payload);
                    case ApiMethod.Delete:
                        return (params = '', payload = {}) => this.restMethodDelete(action, params, payload);
                }

            }

            /**
             * @param {string} action
             * @param {string} params
             * @param {object} options
             * @param {boolean} cache
             * @return {Promise<any>}
             */
            restMethodGet(action, params, options, cache) {
                const _params = this.createParams(params);
                const url = `${this.apiConfig.hosts[this.currentHostName].url.http}/${action}${_params}`;
                return this.http.get(url)
                    .then((response) => response.data)
                    .catch(error => {
                        console.log('OOPS!', error);
                        throw error;
                    })
            }

            /**
             * @param {string} action
             * @param {string} path
             * @param {string} params
             * @return {Promise<any>}
             */
            restMethodPost(action, path, params) {
                const _path = !!path && ('/' + path) || '';
                const url = `${this.apiConfig.hosts[this.currentHostName].url.http}/${action}${_path}`;
                return this.http.post(url, params)
                    .then((response) => response.data)
                    .catch(error => {
                        console.log('OOPS!', error);
                        throw error;
                    })
            }

            restMethodPut(action, params, payload) {
                const _params = params ? '/' + params : '';
                const url = `${this.apiConfig.hosts[this.currentHostName].url.http}/${action}${_params}`;
                return this.http.put(url, payload)
                    .then((response) => response.data)
                    .catch(error => {
                        console.log('OOPS!', error);
                        throw error;
                    })
            }

            restMethodDelete(action, params, payload) {
                const _params = params ? '/' + params : '';
                const url = `${this.apiConfig.hosts[this.currentHostName].url.http}/${action}${_params}`;
                return this.http.delete(url, {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: payload
                })
                    .then((response) => response.data)
                    .catch(error => {
                        console.log('OOPS!', error);
                        throw error;
                    })
            }

            /**
             * @param {any} params
             * @param {any|object} options
             * @return {string}
             */
            createParams(params, options = {}) {

                if (typeof params === 'string' || typeof params === 'number') {
                    return params.toString();
                }

                if (Object(params) === params) {
                    //extract url from params object (field name: '_url')
                    let _params = '';
                    if (params.hasOwnProperty('_url')) {
                        _params += params['_url'];
                        delete params['_url'];
                    }
                    return _params + '?' + (new URLSearchParams(params)).toString();
                }
            }
        }

        return new SocialAPIService();
    }]);
